import { render, staticRenderFns } from "./ConferenceManager.vue?vue&type=template&id=148e06b4"
import script from "./ConferenceManager.vue?vue&type=script&lang=js"
export * from "./ConferenceManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports